import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverDocumentsListComponent } from './components/driver-documents-list/driver-documents-list.component';
import { DriverDocumentsListService } from './services/driver-documents-list.service';
import { SearchComponent } from "../../_shared/components/filters/search/search.component";
import { DriverDocumentsDetailsComponent } from './components/driver-documents-details/driver-documents-details.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-driver-documents',
  standalone: true,
  imports: [CommonModule, DriverDocumentsListComponent, SearchComponent, DriverDocumentsDetailsComponent, TranslocoDirective],
  templateUrl: './driver-documents.component.html',
  styleUrl: './driver-documents.component.scss'
})
export class DriverDocumentsComponent implements OnInit {
  public listLoaded: boolean = false;
  public detailsLoaded: boolean = false;
  public isDriverFound: boolean = true;
  public isSearching: boolean = false;
  public isSearchDisabled: boolean = false;
  public hasDrivers = signal(null);
  public driverId: number;
  private driverDocumentsListService = inject(DriverDocumentsListService);

  ngOnInit(): void {
    this.onSearchTermUpdate('');
  }

  onSearchTermUpdate(searchTerm: string): void {
    this.driverDocumentsListService.updateSearchTerm(searchTerm);
    this.isSearching = searchTerm.trim().length > 0;
    this.listLoaded = false;
  }
}